import { Link } from 'react-router-dom';
import { Languages } from 'lucide-react';
import { LOCALES, type Locale, type LocaleConfig } from '@/lib/i18n';

/**
 * Links to the same page in every language. Real anchors, so crawlers find the
 * localised URLs from the page itself and not only from hreflang.
 */
export function LanguageSwitcher({ current, pathFor, label, locales = LOCALES }: { current: Locale; pathFor: (locale: Locale) => string; label: string; locales?: LocaleConfig[] }) {
  return (
    <nav aria-label={label} className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
      <Languages aria-hidden className="h-4 w-4 text-gray-500" />
      {locales.map((l) =>
        l.code === current ? (
          <span key={l.code} className="font-semibold text-white" aria-current="page" lang={l.lang}>{l.nativeName}</span>
        ) : (
          <Link key={l.code} to={pathFor(l.code)} hrefLang={l.hreflang} lang={l.lang} className="text-primary-300 hover:text-primary-200">
            {l.nativeName}
          </Link>
        ),
      )}
    </nav>
  );
}
